import useApi from '~/composables/useApi';
import { Document, DocumentFilterInput } from './types';
import document from './document.gql';
import {
	useContext,
} from '@nuxtjs/composition-api';
import { json } from 'stream/consumers';

interface DocumentOutput {
    items: Array<Document>,
}

export const useDocuments = () => {
	const { query } = useApi();
	const { app } = useContext();
    const storeCode = app.$vsf.$magento.config.state.getStore() ?? 'en';

	const getDocument = async (attachmentId: number): Promise<DocumentOutput> => {
		const filter = {
			attachment_id: attachmentId,
            store_code: storeCode,
		};

		const { data } = await query<{ documents: DocumentOutput }>(document, { filter });
		const items = data?.documents?.items ?? [];

		return {
			items: items,
		};
	};

	const getAllDocuments = async (productSku): Promise<DocumentOutput> => {
		const filter = {
			product_sku: productSku,
            store_code: storeCode,
		};

		const { data } = await query<{ documents: DocumentOutput }>(document, { filter });
		const items = data?.documents?.items ?? [];

		return {
			items: items,
		};
	};

	return {
		getAllDocuments,
		getDocument
	};
}

export default useDocuments;
